/** @jsxImportSource theme-ui */
import { Container, Flex } from 'theme-ui';
import VossErrorLogs from '@/containers/vossErrorLogs/VossErrorLogs';

const VossErrorLogsPage = () => {
    return (
        <Container>
            <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                <VossErrorLogs />
            </Flex>
        </Container>
    );
};

export default VossErrorLogsPage;
